import PropTypes from "prop-types";
import React from "react";

function LayoutCardsWrapper({ children }) {

  return (
    <div
      style={{
        alignItems: "start",
        borderRadius: "16px",
        height: "100%",
        display: "flex",
        padding: "8px 24px 8px 8px"
      }}
    >
      {children}
    </div>
  );
}

LayoutCardsWrapper.defaultProps = {
  children: null,
};
LayoutCardsWrapper.propTypes = {
  children: PropTypes.any,
};

export default LayoutCardsWrapper;
